export default __webpack_public_path__ + "c08a541ac90e2bb6f62655e45c1ca380.png";